import { SellerBillingPage } from '@/modules/seller/pages/Billing/seller-billing-page'

export function DealerBillingPage() {
  return <SellerBillingPage />
}
